// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { CreateSavedSearchUsersMeSavedSearchesPostData, CreateSavedSearchUsersMeSavedSearchesPostErrors, CreateSavedSearchUsersMeSavedSearchesPostResponses, DeleteSavedSearchUsersMeSavedSearchesSearchIdDeleteData, DeleteSavedSearchUsersMeSavedSearchesSearchIdDeleteErrors, DeleteSavedSearchUsersMeSavedSearchesSearchIdDeleteResponses, ExecuteSavedSearchUsersMeSavedSearchesSearchIdExecutePostData, ExecuteSavedSearchUsersMeSavedSearchesSearchIdExecutePostErrors, ExecuteSavedSearchUsersMeSavedSearchesSearchIdExecutePostResponses, GetAvailableFiltersProductsFiltersGetData, GetAvailableFiltersProductsFiltersGetErrors, GetAvailableFiltersProductsFiltersGetResponses, GetCurrentUserInfoUsersMeGetData, GetCurrentUserInfoUsersMeGetResponses, GetFilterBrandsProductsFiltersBrandsGetData, GetFilterBrandsProductsFiltersBrandsGetResponses, GetFilterCategoriesProductsFiltersCategoriesGetData, GetFilterCategoriesProductsFiltersCategoriesGetResponses, GetFilterSitesProductsFiltersSitesGetData, GetFilterSitesProductsFiltersSitesGetErrors, GetFilterSitesProductsFiltersSitesGetResponses, GetProductProductsProductIdGetData, GetProductProductsProductIdGetErrors, GetProductProductsProductIdGetResponses, GetProductsProductsGetData, GetProductsProductsGetErrors, GetProductsProductsGetResponses, GetProductUsersUserIdGetData, GetProductUsersUserIdGetErrors, GetProductUsersUserIdGetResponses, GetSavedSearchUsersMeSavedSearchesSearchIdGetData, GetSavedSearchUsersMeSavedSearchesSearchIdGetErrors, GetSavedSearchUsersMeSavedSearchesSearchIdGetResponses, GetSiteSitesSiteIdGetData, GetSiteSitesSiteIdGetErrors, GetSiteSitesSiteIdGetResponses, GetSitesSitesGetData, GetSitesSitesGetErrors, GetSitesSitesGetResponses, GetUserSavedSearchesUsersMeSavedSearchesGetData, GetUserSavedSearchesUsersMeSavedSearchesGetResponses, InviteUserUsersInvitePostData, InviteUserUsersInvitePostErrors, InviteUserUsersInvitePostResponses, LoginUserLoginPostData, LoginUserLoginPostErrors, LoginUserLoginPostResponses, LogoutUserUsersLogoutPostData, LogoutUserUsersLogoutPostResponses, RegisterUserRegisterPostData, RegisterUserRegisterPostErrors, RegisterUserRegisterPostResponses, UpdateSavedSearchUsersMeSavedSearchesSearchIdPatchData, UpdateSavedSearchUsersMeSavedSearchesSearchIdPatchErrors, UpdateSavedSearchUsersMeSavedSearchesSearchIdPatchResponses, UpdateSiteAdminSitesSiteIdPostData, UpdateSiteAdminSitesSiteIdPostErrors, UpdateSiteAdminSitesSiteIdPostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Update Site
 */
export const updateSiteAdminSitesSiteIdPost = <ThrowOnError extends boolean = false>(options: Options<UpdateSiteAdminSitesSiteIdPostData, ThrowOnError>) => (options.client ?? client).post<UpdateSiteAdminSitesSiteIdPostResponses, UpdateSiteAdminSitesSiteIdPostErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/admin/sites/{site_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register User
 */
export const registerUserRegisterPost = <ThrowOnError extends boolean = false>(options: Options<RegisterUserRegisterPostData, ThrowOnError>) => (options.client ?? client).post<RegisterUserRegisterPostResponses, RegisterUserRegisterPostErrors, ThrowOnError>({
    url: '/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login User
 */
export const loginUserLoginPost = <ThrowOnError extends boolean = false>(options: Options<LoginUserLoginPostData, ThrowOnError>) => (options.client ?? client).post<LoginUserLoginPostResponses, LoginUserLoginPostErrors, ThrowOnError>({
    url: '/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Products
 */
export const getProductsProductsGet = <ThrowOnError extends boolean = false>(options?: Options<GetProductsProductsGetData, ThrowOnError>) => (options?.client ?? client).get<GetProductsProductsGetResponses, GetProductsProductsGetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/products/',
    ...options
});

/**
 * Get Available Filters
 */
export const getAvailableFiltersProductsFiltersGet = <ThrowOnError extends boolean = false>(options?: Options<GetAvailableFiltersProductsFiltersGetData, ThrowOnError>) => (options?.client ?? client).get<GetAvailableFiltersProductsFiltersGetResponses, GetAvailableFiltersProductsFiltersGetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/products/filters',
    ...options
});

/**
 * Get Product
 */
export const getProductProductsProductIdGet = <ThrowOnError extends boolean = false>(options: Options<GetProductProductsProductIdGetData, ThrowOnError>) => (options.client ?? client).get<GetProductProductsProductIdGetResponses, GetProductProductsProductIdGetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/products/{product_id}',
    ...options
});

/**
 * Get Filter Brands
 *
 * Return list of brands with product counts for filters
 *
 * @deprecated
 */
export const getFilterBrandsProductsFiltersBrandsGet = <ThrowOnError extends boolean = false>(options?: Options<GetFilterBrandsProductsFiltersBrandsGetData, ThrowOnError>) => (options?.client ?? client).get<GetFilterBrandsProductsFiltersBrandsGetResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/products/filters/brands',
    ...options
});

/**
 * Get Filter Categories
 *
 * Return list of categories with product counts for filters
 *
 * @deprecated
 */
export const getFilterCategoriesProductsFiltersCategoriesGet = <ThrowOnError extends boolean = false>(options?: Options<GetFilterCategoriesProductsFiltersCategoriesGetData, ThrowOnError>) => (options?.client ?? client).get<GetFilterCategoriesProductsFiltersCategoriesGetResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/products/filters/categories',
    ...options
});

/**
 * Get Filter Sites
 *
 * Return list of sites with product counts for filters
 *
 * @deprecated
 */
export const getFilterSitesProductsFiltersSitesGet = <ThrowOnError extends boolean = false>(options?: Options<GetFilterSitesProductsFiltersSitesGetData, ThrowOnError>) => (options?.client ?? client).get<GetFilterSitesProductsFiltersSitesGetResponses, GetFilterSitesProductsFiltersSitesGetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/products/filters/sites',
    ...options
});

/**
 * Get Sites
 */
export const getSitesSitesGet = <ThrowOnError extends boolean = false>(options?: Options<GetSitesSitesGetData, ThrowOnError>) => (options?.client ?? client).get<GetSitesSitesGetResponses, GetSitesSitesGetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/sites/',
    ...options
});

/**
 * Get Site
 */
export const getSiteSitesSiteIdGet = <ThrowOnError extends boolean = false>(options: Options<GetSiteSitesSiteIdGetData, ThrowOnError>) => (options.client ?? client).get<GetSiteSitesSiteIdGetResponses, GetSiteSitesSiteIdGetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/sites/{site_id}',
    ...options
});

/**
 * Logout User
 */
export const logoutUserUsersLogoutPost = <ThrowOnError extends boolean = false>(options?: Options<LogoutUserUsersLogoutPostData, ThrowOnError>) => (options?.client ?? client).post<LogoutUserUsersLogoutPostResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/users/logout',
    ...options
});

/**
 * Get Current User Info
 */
export const getCurrentUserInfoUsersMeGet = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserInfoUsersMeGetData, ThrowOnError>) => (options?.client ?? client).get<GetCurrentUserInfoUsersMeGetResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/users/me',
    ...options
});

/**
 * Get Product
 */
export const getProductUsersUserIdGet = <ThrowOnError extends boolean = false>(options: Options<GetProductUsersUserIdGetData, ThrowOnError>) => (options.client ?? client).get<GetProductUsersUserIdGetResponses, GetProductUsersUserIdGetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/users/{user_id}',
    ...options
});

/**
 * Invite User
 */
export const inviteUserUsersInvitePost = <ThrowOnError extends boolean = false>(options: Options<InviteUserUsersInvitePostData, ThrowOnError>) => (options.client ?? client).post<InviteUserUsersInvitePostResponses, InviteUserUsersInvitePostErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/users/invite',
    ...options
});

/**
 * Get User Saved Searches
 */
export const getUserSavedSearchesUsersMeSavedSearchesGet = <ThrowOnError extends boolean = false>(options?: Options<GetUserSavedSearchesUsersMeSavedSearchesGetData, ThrowOnError>) => (options?.client ?? client).get<GetUserSavedSearchesUsersMeSavedSearchesGetResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/users/me/saved-searches',
    ...options
});

/**
 * Create Saved Search
 */
export const createSavedSearchUsersMeSavedSearchesPost = <ThrowOnError extends boolean = false>(options: Options<CreateSavedSearchUsersMeSavedSearchesPostData, ThrowOnError>) => (options.client ?? client).post<CreateSavedSearchUsersMeSavedSearchesPostResponses, CreateSavedSearchUsersMeSavedSearchesPostErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/users/me/saved-searches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Saved Search
 */
export const deleteSavedSearchUsersMeSavedSearchesSearchIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteSavedSearchUsersMeSavedSearchesSearchIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteSavedSearchUsersMeSavedSearchesSearchIdDeleteResponses, DeleteSavedSearchUsersMeSavedSearchesSearchIdDeleteErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/users/me/saved-searches/{search_id}',
    ...options
});

/**
 * Get Saved Search
 */
export const getSavedSearchUsersMeSavedSearchesSearchIdGet = <ThrowOnError extends boolean = false>(options: Options<GetSavedSearchUsersMeSavedSearchesSearchIdGetData, ThrowOnError>) => (options.client ?? client).get<GetSavedSearchUsersMeSavedSearchesSearchIdGetResponses, GetSavedSearchUsersMeSavedSearchesSearchIdGetErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/users/me/saved-searches/{search_id}',
    ...options
});

/**
 * Update Saved Search
 */
export const updateSavedSearchUsersMeSavedSearchesSearchIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateSavedSearchUsersMeSavedSearchesSearchIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateSavedSearchUsersMeSavedSearchesSearchIdPatchResponses, UpdateSavedSearchUsersMeSavedSearchesSearchIdPatchErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/users/me/saved-searches/{search_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Execute Saved Search
 */
export const executeSavedSearchUsersMeSavedSearchesSearchIdExecutePost = <ThrowOnError extends boolean = false>(options: Options<ExecuteSavedSearchUsersMeSavedSearchesSearchIdExecutePostData, ThrowOnError>) => (options.client ?? client).post<ExecuteSavedSearchUsersMeSavedSearchesSearchIdExecutePostResponses, ExecuteSavedSearchUsersMeSavedSearchesSearchIdExecutePostErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'session',
            type: 'apiKey'
        }],
    url: '/users/me/saved-searches/{search_id}/execute',
    ...options
});
